<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WJq1Oq/tc-custom/9781504076296.jpg?1702817904199" alt="This image is the cover for the book Diary and Observations of Thomas Alva Edison"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diary and Observations of Thomas Alva Edison
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Gain insight into the unique thinking and philosophy of the world’s most prolific inventor with this collection of his writings.</b></p><p>American scientist and businessman Thomas Edison contributed much to the well-being and comfort of our modern life. He gave us the electric light, the phonograph, and the motion-picture camera, along with more than one thousand other inventions. Edison was, as fellow inventor Guglielmo Marconi put it, “one of the world’s greatest benefactors.”</p> In this volume, editor Dagobert D. Runes presents Edison’s diary along with a selection of his social and philosophical ideas taken from available notes, statements, and observations. Readers will discover that many of Edison’s casual remarks made decades ago have a definite contemporary significance. His propositions in ethics, philosophy, music, and education show a rare combination of whimsy and deep sincerity.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dagobert D. Runes
      </h2>
      
      <p class="authorDescription body article">Dagobert D. Runes was born in Zastavna, Bukovina, Austria-Hungary (now in Ukraine), and received a doctorate in philosophy from the University of Vienna&#160;in 1924. In 1926 he emigrated to the United States, where he became editor of the<I> Modern Thinker</I> and later <I>Current Digest</I>. From 1931 to 1934 he was director of the Institute for Advanced Education in New York City, and in 1941 he founded the Philosophical Library, a spiritual organization and publishing house.<BR /><BR /> Runes published an English translation of Karl Marx&rsquo;s <I>On the Jewish Question</I> under the title <I>A World Without Jews</I>, featuring an introduction that was clearly antagonistic to extreme Marxism and &ldquo;its materialism,&rdquo; yet he did not entirely negate Marxist theory. He also edited several works presenting the ideas and history of philosophy to a general audience, including his <I>Dictionary of Philosophy</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Philosophical Library/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f7abbcbe